"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m8.173 2.535 7.488 2.481a.496.496 0 0 1 .005.941L8.244 8.501a.492.492 0 0 1-.312.003L4.395 7.365V9.99c.322.312 1.388 1.154 3.508 1.154 2.072 0 3.28-.716 3.686-1.008V8.27l.993-.337v2.442a.495.495 0 0 1-.154.36c-.06.057-1.507 1.402-4.525 1.402-3.06 0-4.34-1.579-4.394-1.646a.498.498 0 0 1-.107-.307V7.047l-1.211-.39v1.969c.243.176.41.448.41.77a.956.956 0 0 1-.322.71l.815 3.79-.97.208-.425-1.97-.464 1.967-.966-.228.866-3.668a.953.953 0 0 1-.468-.809c0-.375.22-.69.531-.85V6.337l-.854-.274a.497.497 0 0 1-.008-.942l7.52-2.584a.497.497 0 0 1 .317-.002Zm-6.105 3.04 6.01 1.933 5.873-2.013L8.02 3.53 2.07 5.576Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m12.186 3.503 11.35 3.761a.561.561 0 0 1 .006 1.066l-11.249 3.857a.56.56 0 0 1-.354.003L6.33 10.386v4.316c.441.448 2.1 1.86 5.507 1.86 3.361 0 5.227-1.198 5.778-1.619v-3.248l1.125-.398v3.91a.567.567 0 0 1-.174.408c-.089.084-2.23 2.073-6.73 2.073-4.546 0-6.432-2.323-6.51-2.422a.559.559 0 0 1-.12-.348v-4.895L2.99 9.311v3.107a1.462 1.462 0 0 1 .16 2.524l1.172 5.456-1.1.236-.778-3.624-.855 3.616-1.095-.258 1.253-5.303a1.46 1.46 0 0 1 .118-2.723V8.95L.439 8.49a.563.563 0 0 1-.01-1.068l11.398-3.917a.566.566 0 0 1 .36-.002ZM2.393 7.937l9.713 3.125 9.493-3.255-9.586-3.176-9.62 3.306Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m16.248 4.67 15.133 5.015a.75.75 0 0 1 .008 1.421L16.391 16.25a.747.747 0 0 1-.472.004L8.44 13.847v5.755c.588.598 2.8 2.481 7.342 2.481 4.482 0 6.97-1.598 7.705-2.159v-4.33l1.5-.532v5.214a.75.75 0 0 1-.233.543c-.118.113-2.972 2.764-8.972 2.764-6.062 0-8.577-3.097-8.68-3.229a.745.745 0 0 1-.162-.464v-6.526l-2.954-.95v4.143a1.949 1.949 0 0 1 1.083 1.741 1.95 1.95 0 0 1-.869 1.624l1.563 7.275-1.467.315-1.038-4.832-1.139 4.821-1.46-.344 1.67-7.07a1.947 1.947 0 0 1 .157-3.63V11.93l-1.9-.61A.75.75 0 0 1 .57 9.895l15.2-5.222a.755.755 0 0 1 .48-.003ZM3.19 10.582l12.951 4.167 12.657-4.34-12.78-4.235L3.19 10.582Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m24.344 6.993 23.014 7.626a.935.935 0 0 1 .01 1.775l-22.809 7.822a.934.934 0 0 1-.59.005l-11.64-3.745v9.108c.836.852 4.322 3.901 11.37 3.901 6.98 0 10.87-2.579 11.921-3.391v-6.479l1.874-.753v7.67a.934.934 0 0 1-.291.68c-.178.17-4.46 4.147-13.504 4.147-9.122 0-12.886-4.636-13.042-4.834a.935.935 0 0 1-.2-.58V19.874l-4.902-1.577v6.478a2.968 2.968 0 0 1 1.851 2.75c0 1.168-.68 2.17-1.661 2.655l.163-.035L8.22 40.9l-1.832.394-1.726-8.032-1.894 8.013-1.823-.43 2.49-10.533a2.965 2.965 0 0 1-1.974-2.788c0-1.38.945-2.53 2.22-2.865v-6.966L.65 16.719a.937.937 0 0 1-.017-1.778l23.112-7.945a.93.93 0 0 1 .599-.003Zm-20.44 8.805 20.342 6.544 19.885-6.818L24.055 8.87 3.904 15.798Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m32.458 9.325 30.686 10.167a1.25 1.25 0 0 1 .013 2.367L32.746 32.287a1.245 1.245 0 0 1-.788.008L16.44 27.301v12.144c1.114 1.135 5.763 5.201 15.16 5.201 9.305 0 14.492-3.439 15.895-4.522v-8.638l2.498-1.005V40.71c0 .341-.14.669-.388.904-.238.227-5.946 5.53-18.005 5.53-12.163 0-17.182-6.18-17.39-6.444a1.246 1.246 0 0 1-.268-.774V26.498l-6.534-2.102v8.637A3.958 3.958 0 0 1 9.875 36.7a3.95 3.95 0 0 1-2.215 3.54l.218-.047 3.082 14.342-2.443.526-2.301-10.71L3.69 55.034l-2.43-.574 3.32-14.043A3.953 3.953 0 0 1 1.947 36.7c0-1.84 1.26-3.373 2.961-3.82v-9.288l-4.043-1.3a1.25 1.25 0 0 1-.023-2.37L31.66 9.329c.258-.09.54-.091.798-.004ZM5.205 21.064l27.123 8.726 26.513-9.092-26.768-8.87-26.868 9.236Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconTuition = function IconTuition(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Tuition' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Tuition"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconTuition.sizes = [16, 24, 32, 48, 64];
IconTuition.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconTuition;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/products/Tuition.js
// module id = 2279
// module chunks = 0